import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 *  ISINs consist of:
 *  two alphabetic characters, which are the ISO 3166-1 alpha-2 code for the issuing country
 *  nine alpha-numeric characters (the National Securities Identifying Number, or NSIN, which identifies the security, padded as necessary with leading zeros)
 *  and one numerical check digit
 */
function validateIsin(isin): boolean {
    // eslint-disable-next-line max-len
    const re = /^(?:[A-Z]{2})(?:[A-Z0-9]{9})(?:[0-9]{1})$/;
    return re.test(String(isin));
}

export function IsinValidator(control: AbstractControl): ValidationErrors {
    if (control.dirty) {
        if (!validateIsin(control.value)) {
            return {
                isin: true
            };
        } else {
            return null;
        }
    } else {
        return null;
    }
}
